
<template>
  <div class="relative">
    <div class="vx-navbar-wrapper config-navbar" style="z-index:41000">
      <vs-navbar
        :color="navbarColor"
        :class="classObj"
        class="vx-navbar navbar-custom cusss-navbar headNavbar"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer mr-1"
          icon="MenuIcon"
          @click.stop="showSidebar"
        ></feather-icon>
        <template>
          <img src="../../assets/images/sappasamit.png" width="45px" height="45px" alt />
          <h5
            id="titles"
          >ระบบตรวจสอบและติดตามเรือขนส่งน้ำมัน สำนักตรวจสอบป้องกันและปราบปราม กรมสรรพสามิต (ระบบ Real Time Surveillance (RTS))</h5>
          <h3 id="titlePhone">RTS</h3>
        </template>

        <vs-spacer></vs-spacer>

        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer mr-4">
          <span class="cursor-pointer flex i18n-locale">
            <img
              :src="require(`@/assets/images/flags/${$i18n.locale}.png`)"
              :alt="$i18n.locale"
              class="h-4 w-5"
            />
            <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>
          </span>
          <vs-dropdown-menu class="w-48 i18n-dropdown">
            <vs-dropdown-item @click="updateLocale('en')">
              <img class="h-4 w-5 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;EN
            </vs-dropdown-item>
            <vs-dropdown-item @click="updateLocale('th')">
              <img class="h-4 w-5 mr-1" src="@/assets/images/flags/th.png" alt="th" /> &nbsp;TH
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- NOTIFICATIONS -->
        <vs-dropdown v-if="member.roles_mask==1 || member.roles_mask==2" class="cursor-pointer">
          <feather-icon
            :badge="amoutNotifacation"
            icon="BellIcon"
            class="cursor-pointer mt-1 sm:mr-6 mr-2"
          ></feather-icon>
          <vs-dropdown-menu class="notification-dropdown dropdown-custom">
            <div class="notification-top text-center p-5 bg-primary text-white">
              <h3 class="text-white">10 New</h3>
              <p style="cursor: pointer;" @click="readEventAll()">Mark As Read</p>
            </div>
            <VuePerfectScrollbar
              ref="mainSidebarPs"
              class="scroll-area--nofications-dropdown p-0 mb-10"
            >
              <ul class="bordered-items">
                <li
                  v-for="event in eventNotification"
                  :key="event.id"
                  class="flex justify-between px-4 py-4 notification cursor-pointer"
                  @click="detailNotification(event.id)"
                >
                  <div class="flex items-start" @click="readEvent(event.id)">
                    <div class="mx-2">
                      <span class="font-medium block notification-title">{{ event.to_s }}</span>
                    </div>
                  </div>
                  <!-- <small
                    v-if="event.read_at==null"
                    class="mt-1 whitespace-no-wrap"
                    @click="readEvent(event.id),detailNotification(event.id)"
                  >
                    {{ event.updated_at|sumdate }} {{ event.updated_at|sumtime }}
                    <br />
                    <font color="red">ยังไม่อ่าน</font>
                  </small>-->
                  <small
                    v-if="event.read_at==null"
                    class="mt-1 whitespace-no-wrap"
                    @click="readEvent(event.id)"
                  >
                    {{ event.updated_at|sumdate }} {{ event.updated_at|sumtime }}
                    <br />
                    <font color="red">ยังไม่อ่าน</font>
                  </small>
                  <small
                    v-else
                    class="mt-1 whitespace-no-wrap"
                    @click="detailNotification(event.id)"
                  >
                    {{ event.updated_at|sumdate }} {{ event.updated_at|sumtime }}
                    <br />
                    <font color="green">อ่านเเล้ว</font>
                  </small>
                </li>
              </ul>
            </VuePerfectScrollbar>
            <div
              class="checkout-footer fixed pin-b rounded-b-lg text-primary w-full p-2 font-semibold text-center border border-b-0 border-l-0 border-r-0 border-solid border-grey-light cursor-pointer"
            >
              <router-link to="/vesselTracking/EventNotification">
                <span>View All Notifications</span>
              </router-link>
            </div>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- USER META -->
        <div class="the-navbar__user-meta flex items-center">
          <div class="text-right leading-tight hidden sm:block">
            <p v-if="member != ''" class="font-semibold">{{ member.nickname }}</p>
            <p v-else class="font-semibold">no member</p>
            <small v-if="member!=''">{{ member.firstname }}</small>
            <small v-else>User</small>
          </div>
          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <div class="con-img ml-3">
              <img
                v-if="activeUserImg.startsWith('http')"
                key="onlineImg"
                :src="activeUserImg"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
              <img
                v-else
                key="localImg"
                :src="require(`@/assets/images/portrait/small/${activeUserImg}`)"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
            </div>
            <vs-dropdown-menu>
              <ul style="min-width: 9rem">
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="logout"
                >
                  <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">Logout</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "firebase/auth";
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";
import {
  API_MAKE_READ,
  API_MAKE_READ_ALL,
  API_UNREAD_COUNT_NOTIFY,
  API_POSITION_TYPE_FIXES,
  API_GET_SHIP_TYPE,
  API_GET_MIDS,
  API_GET_NOTIFICATION,
  API_ADMIN_VESSEL_GROUP,
  API_ADMIN_GET_ZONE,
  API_SIGN_OUT
} from "@/constants/api";
import { mapState } from "vuex";

export default {
  name: "TheNavbar",
  filters: {
    sumdate: function(string) {
      if (string != null) {
        let year = string.substring(0, 4);
        let sumYear = parseInt(year) + 543;
        let mount = string.substring(5, 7);
        let day = string.substring(8, 10);
        let date = day + "/" + mount + "/" + sumYear;

        return date;
      } else {
        return string;
      }
    },
    sumtime: function(string) {
      if (string != null) {
        return string.substring(11, 19);
      } else {
        return string;
      }
    }
  },
  props: {
    navbarColor: {
      type: String,
      default: "#fff"
    }
  },
  data() {
    return {
      member: "",
      exciseList: [],
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      searchQuery: "",
      showFullSearch: false,
      autoFocusSearch: false,
      showBookmarkPagesDropdown: false,
      titleName: this.$store.state.titlePage,
      eventNotification: [],
      amoutNotifacation: null,
      baseStations: [],
      chkEvent: false,
      accessEmail: "",
      accessToken: ""
    };
  },
  computed: mapState({
    titlePage: state => state.titlePage,
    // HELPER
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },
    // NAVBAR STYLE
    classObj() {
      if (this.sidebarWidth == "default") return "navbar-default";
      else if (this.sidebarWidth == "reduced") return "navbar-reduced";
      else if (this.sidebarWidth) return "navbar-full";
    },

    // I18N
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale == "en") return { flag: "us", lang: "English" };
      else if (locale == "th") return { flag: "th", lang: "ไทย" };
    },

    // BOOKMARK & SEARCH
    data() {
      return this.$store.state.navbarSearchAndPinList;
    },
    starredPages() {
      return this.$store.state.starredPages;
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesLimited", list);
      }
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesMore", list);
      }
    },

    // CART DROPDOWN
    cartItems() {
      return this.$store.state.eCommerce.cartItems.slice().reverse();
    },

    // PROFILE
    user_displayName() {
      return JSON.parse(localStorage.getItem("userInfo")).displayName;
    },
    activeUserImg() {
      return (
        // JSON.parse(localStorage.getItem("userInfo")).photoURL ||
        this.$store.state.AppActiveUser.img
      );
    }
  }),
  watch: {
    titlePage(val) {
      this.titleName = val;
    },
    $route() {
      if (this.showBookmarkPagesDropdown)
        this.showBookmarkPagesDropdown = false;
    }
  },
  created() {
    this.$store.dispatch("updateTitlePage", "Realtime mornitoring");
    if (localStorage.getItem("userInfo") == null) {
      this.member = "";
      this.$router.push("/pages/login");
    } else {
      this.member = JSON.parse(localStorage.getItem("userInfo"));
      this.accessEmail = localStorage.getItem("accessEmail");
      this.accessToken = localStorage.getItem("accessToken");
    }
  },
  mounted() {
    if (this.member.roles_mask == 1 || this.member.roles_mask == 2) {
      this.getCountRead1();
      this.getEventNotificationsData();
      this.getVesselGroups();
      this.getZones();
      this.getMid();
      this.getShipTypes();
      this.getPositionFixType();
    }
  },
  methods: {
    detailNotification(id) {
      localStorage.setItem("detailNoti", JSON.stringify(id));
      let routeData = this.$router.resolve({ name: "DetailNotification" });
      window.open(routeData.href, "_blank");
    },
    readEvent(id) {
      const url = API_MAKE_READ(id);
      $.ajax({
        method: "POST",
        url,
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      }).done(msg => {
        console.log("readEvent:", msg);
        this.getEventNotificationsData();
        this.getCountRead1();
      });
    },
    readEventAll() {
      const url = API_MAKE_READ_ALL();
      $.ajax({
        method: "POST",
        url,
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      }).done(msg => {
        console.log("readEventAll:", msg);
        this.getCountRead1();
      });
    },
    getCountRead1() {
      const url = API_UNREAD_COUNT_NOTIFY();
      axios
        .get(url, {
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          if (response.data != this.amoutNotifacation) {
            var x = new Audio(
              `https://notificationsounds.com/storage/sounds/file-sounds-1020-milestone.mp3`
            );
            x.play();
            this.getEventNotificationsData();
          }

          this.amoutNotifacation = response.data;
          setTimeout(() => {
            this.getCountRead2();
          }, 10000);
        })
        .catch(error => {
          console.log("Error call apis :", error);
          setTimeout(() => {
            this.getCountRead2();
          }, 10000);
        });
    },
    getCountRead2() {
      const url = API_UNREAD_COUNT_NOTIFY();
      axios
        .get(url, {
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          console.log("count un read2 : ", response.data);
          if (response.data != this.amoutNotifacation) {
            var x = new Audio(
              `https://notificationsounds.com/storage/sounds/file-sounds-1020-milestone.mp3`
            );
            x.play();
            this.getEventNotificationsData();
          }
          this.amoutNotifacation = response.data;

          setTimeout(() => {
            this.getCountRead1();
          }, 10000);
        })
        .catch(error => {
          console.log("Error call apis :", error);
          setTimeout(() => {
            this.getCountRead1();
          }, 10000);
        });
    },
    getPositionFixType() {
      const url = API_POSITION_TYPE_FIXES();
      axios
        .get(url, {
          params: {
            limit: 50
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          this.$store.dispatch("updatePositionFixType", response.data);
        })
        .catch(error => {
          console.log("Error call apis :", error);
        });
    },
    getShipTypes() {
      const url = API_GET_SHIP_TYPE();
      axios
        .get(url, {
          params: {
            limit: 100
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          this.$store.dispatch("updateShipTypes", response.data);
        })
        .catch(error => {
          console.log("Error call apis :", error);
        });
    },
    getMid() {
      const url = API_GET_MIDS();
      axios
        .get(url, {
          params: {
            limit: 50
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          this.$store.dispatch("updateMids", response.data);
        })
        .catch(error => {
          console.log("Error call apis :", error);
        });
    },
    getEventNotificationsData() {
      const url = API_GET_NOTIFICATION();
      axios
        .get(url, {
          params: {
            limit: 10
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          this.eventNotification = response.data;
        })
        .catch(error => {
          console.log("api event notification data error  :", error);
        });
    },
    getVesselGroups() {
      const url = API_ADMIN_VESSEL_GROUP();
      axios
        .get(url, {
          params: {
            limit: 10
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          this.$store.dispatch("updateVesselGroups", response.data);
        })
        .catch(error => {
          console.log("Error call apis :", error);
        });
    },
    getZones() {
      const url = API_ADMIN_GET_ZONE();
      axios
        .get(url, {
          params: {
            limit: 50
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          this.$store.dispatch("updateZones", response.data);
        })
        .catch(error => {
          console.log("Error call apis :", error);
        });
    },

    updateLocale(locale) {
      this.$i18n.locale = locale;
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
    },
    selected(item) {
      this.$router.push(item.url);
      this.showFullSearch = false;
    },
    actionClicked(item) {
      // e.stopPropogation();
      this.$store.dispatch("updateStarredPage", {
        index: item.index,
        val: !item.highlightAction
      });
    },
    showNavbarSearch() {
      this.showFullSearch = true;
    },
    showSearchbar() {
      this.showFullSearch = true;
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? `${seconds} sec ago` : "just now");
      }
      return "Just Now";
    },
    logout() {
      const url = API_SIGN_OUT();
      axios
        .delete(url, {
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(() => {
          localStorage.clear();
          let routeData = this.$router.resolve({ name: "DetailReport" });
          window.open(routeData.href, "_parent");
        })
        .catch(error => {
          console.log("logout faild", error);
          localStorage.clear();
          let routeData = this.$router.resolve({ name: "pageLogin" });
          window.open(routeData.href, "_parent");
        });
    },
    outside: function() {
      this.showBookmarkPagesDropdown = false;
    },

    // CART DROPDOWN
    removeItemFromCart(item) {
      this.$store.dispatch("eCommerce/toggleItemInCart", item);
    }
  },
  // eslint-disable-next-line vue/order-in-components
  directives: {
    "click-outside": {
      bind: function(el, binding) {
        const bubble = binding.modifiers.bubble;
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener("click", handler);
      },

      unbind: function(el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  },
  // eslint-disable-next-line vue/order-in-components
  components: {
    VxAutoSuggest,
    VuePerfectScrollbar,
    draggable
  }
};
</script>

<style scoped>
.config-navbar {
  padding-top: 2px;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
}

.cusss-navbar {
  width: 100%;
  border-radius: 0;
}

/* div{
  width: 100%;
  height: 300px;
  background-color: red;
}
@media screen and (min-width: 768px) {
  div{
    width: 500px;
    height: 300px;
    background-color: blue;
    margin: auto;
  }
}
@media screen and (min-width: 1024px) {
  div{
    width: 300px;
    height: 300px;
    background-color: orange;
  }
} */

#titles {
  display: none;
}
#titlePhone {
  display: block;
}
.content-area-reduced .vs-navbar.vx-navbar {
  width: unset;
}

.vs-navbar.vx-navbar.navbar-full {
  width: calc(126% - 4.4rem);
}

@media screen and (min-width: 375px) {
  #titles {
    display: none;
  }
  #titlePhone {
    display: block;
  }
  .content-area-reduced .vs-navbar.vx-navbar {
    width: unset;
  }

  .vs-navbar.vx-navbar.navbar-full {
    width: calc(122% - 4.4rem);
  }
}
@media screen and (min-width: 425px) {
  #titles {
    display: none;
  }
  #titlePhone {
    display: block;
  }
  .content-area-reduced .vs-navbar.vx-navbar {
    width: unset;
  }

  .vs-navbar.vx-navbar.navbar-full {
    width: calc(120% - 4.4rem);
  }
}

@media screen and (min-width: 576px) {
  #titles {
    display: none;
  }
  #titlePhone {
    display: block;
  }
  .content-area-reduced .vs-navbar.vx-navbar {
    width: unset;
  }

  .vs-navbar.vx-navbar.navbar-full {
    width: calc(114% - 4.4rem);
  }
}

@media screen and (min-width: 768px) {
  #titles {
    display: none;
  }
  #titlePhone {
    display: block;
  }
  .content-area-reduced .vs-navbar.vx-navbar {
    width: unset;
  }

  .vs-navbar.vx-navbar.navbar-full {
    width: calc(111% - 4.4rem);
  }
}

@media screen and (min-width: 1024px) {
  #titles {
    display: block;
  }
  #titlePhone {
    display: none;
  }
  .content-area-reduced .vs-navbar.vx-navbar {
    width: unset;
  }

  .vs-navbar.vx-navbar.navbar-full {
    width: calc(108% - 4.4rem);
  }
}

/* @media screen and (max-width: 320px){
   #titles{
    display: none;
  }
  .content-area-reduced .vs-navbar.vx-navbar {
 width: unset;
}

.vs-navbar.vx-navbar.navbar-full[data-v-dc6398b2] {
    width: calc(126% - 4.4rem);
}
} */

/* @media (min-width: 1025px){

  #titlePhone{
    display: none;
  }
  .vx-navbar-wrapper {
    width: calc(113% - 1.2rem);
}
} */

/* .vx-navbar-wrapper .headNavbar{
  width: 100%;
} */
.content-area-reduced .vs-navbar.vx-navbar {
  width: unset;
}
</style>